const mockUser = {
  login: "google",
  id: 1342004,
  node_id: "MDEyOk9yZ2FuaXphdGlvbjEzNDIwMDQ=",
  avatar_url: "https://avatars.githubusercontent.com/u/1342004?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/google",
  html_url: "https://github.com/google",
  followers_url: "https://api.github.com/users/google/followers",
  following_url: "https://api.github.com/users/google/following{/other_user}",
  gists_url: "https://api.github.com/users/google/gists{/gist_id}",
  starred_url: "https://api.github.com/users/google/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/google/subscriptions",
  organizations_url: "https://api.github.com/users/google/orgs",
  repos_url: "https://api.github.com/users/google/repos",
  events_url: "https://api.github.com/users/google/events{/privacy}",
  received_events_url: "https://api.github.com/users/google/received_events",
  type: "Organization",
  site_admin: false,
  name: "Google",
  company: null,
  blog: "https://opensource.google/",
  location: null,
  email: "opensource@google.com",
  hireable: null,
  bio: "Google ❤️ Open Source",
  twitter_username: "GoogleOSS",
  public_repos: 2425,
  public_gists: 0,
  followers: 17532,
  following: 0,
  created_at: "2012-01-18T01:30:18Z",
  updated_at: "2021-12-30T01:40:20Z",
};

// export default {
//   login: "john-smilga",
//   id: 42133389,
//   node_id: "MDQ6VXNlcjQyMTMzMzg5",
//   avatar_url: "https://avatars3.githubusercontent.com/u/42133389?v=4",
//   gravatar_id: "",
//   url: "https://api.github.com/users/john-smilga",
//   html_url: "https://github.com/john-smilga",
//   followers_url: "https://api.github.com/users/john-smilga/followers",
//   following_url:
//     "https://api.github.com/users/john-smilga/following{/other_user}",
//   gists_url: "https://api.github.com/users/john-smilga/gists{/gist_id}",
//   starred_url:
//     "https://api.github.com/users/john-smilga/starred{/owner}{/repo}",
//   subscriptions_url: "https://api.github.com/users/john-smilga/subscriptions",
//   organizations_url: "https://api.github.com/users/john-smilga/orgs",
//   repos_url: "https://api.github.com/users/john-smilga/repos",
//   events_url: "https://api.github.com/users/john-smilga/events{/privacy}",
//   received_events_url:
//     "https://api.github.com/users/john-smilga/received_events",
//   type: "User",
//   site_admin: false,
//   name: "John Smilga",
//   company: "Coding Addict",
//   blog: "www.johnsmilga.com",
//   location: "Los Angeles",
//   email: null,
//   hireable: null,
//   bio: "Creator of Coding Addict",
//   twitter_username: "john_smilga",
//   public_repos: 152,
//   public_gists: 124,
//   followers: 1495,
//   following: 460,
//   created_at: "2018-08-06T06:48:23Z",
//   updated_at: "2020-07-08T05:01:32Z",
// };

export default mockUser;
